
import React from 'react';
import Approuter from "./utils/Approuter";
import {
  BrowserRouter as Router,
  useLocation,
  Route,HashRouter
} from "react-router-dom";

import store from './app/store';
import { Provider } from 'react-redux';

import Header from "./components/Shared/Header";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// require('dotenv').config();


function App() {
  return (
    <Provider store={store}>
      <div className="App">
             <ToastContainer />
              <HashRouter>
                {/* {window.location.pathname != "/" && */}
                 <Header location={window.location.href}/>
                 {/* } */}
                <Approuter />
              </HashRouter>
      </div>
    </Provider>
  );
}

export default App;
